/**
 * @file 상수나 공통 함수, 유틸리티를 담는 파일
 */

/*** 회사명 ***/
export const COMPANY_NAME_KO = '닷스테이션'
export const COMPANY_NAME_EN = 'DOTSTATION'

/*** 대표자명 ***/
//export const CEO_NAME = '황인혁'
export const CEO_NAME = '이석영'

/*** 회사주소 ***/
//export const COMPANY_ADDRESS = '서울특별시 강남구 삼성로71길 16'
export const COMPANY_ADDRESS = '대구광역시 달서구 성서공단로 11길 62 대구융합R&D센터 5층'

/*** 회사대표번호 ***/
export const COMPANY_CALL = '1522-7116'

/*** 회사팩스번호 ***/
export const COMPANY_FAX = '053-565-0313'

/*** 개인정보책임자 ***/
export const PERSONAL_TERMS_MANAGE_NAME = '이태훈'
export const PERSONAL_TERMS_MANAGE_EMAIL = ''

export const TABLET = 1120
export const MOBILE = 768

/*** 다운로드 url ***/
// export const DOWNLOAD_URL = 'https://leasefile.gobikebank.com/download/web/'
export const DOWNLOAD_URL = 'https://gf.dotstation.kr/download/web/'

/*
 * @constant URL 내부 PAGE URL
 */
export const URL = {
    SEARCH_ID: '?id=',
    SEARCH_AND_ID: '&id=',
    //홈
    HOME: {
        MAIN: '/',
    },
    //회사소개
    COMPANY: {
        MAIN: '/company',
    },
    //스마트 스쿠터
    SCOOTER: {
        MAIN: '/scooter',
        S2: '/scooter/s2',
        PLUS: '/scooter/series',
        UTILITY: '/scooter/series',
        VIVA: '/scooter/viva',
        XL: '/scooter/xl',
        MIX: '/scooter/mix',
        EV_C1: '/scooter/evc1',
    },
    //고고로 네트워크
    NETWORK: {
        MAIN: '/network',
        STATION_LOCATION: '/go-station',
        MAP: '/network/map',
        SERVICE_MAP: '/network/service_map',
    },
    //요금제
    RATE_PLAN: {
        MAIN: '/ratePlan',
    },
    //최신소식
    NEWS: {
        MAIN: '/news',
        BOARD_DETAIL: '/news/board/detail',
    },
    //고객지원
    CUSTOMER: {
        MAIN: '/customer',
        CUSTOMER_CENTER: '/customer/customerCenter',
        EG_CARE: '/customer/egcare',
        SERVICE_NETWORK: '/customer/serviceNetwork',
        STATION_NOTICE_BOARD: '/customer/board',
        SEARCH_STATION_BOARD: '?type=station',
        SEARCH_NOTICE_BOARD: '?type=notice',
        BOARD_DETAIL: '/customer/board/detail',
        MAIN_OLD: '/customer',
        DOWNLOAD: '/customer/download',
        DOWNLOAD_CENTER: '/customer/download_center',
    },
    APPLICATION: '/application',
    SUBSIDY: {
        MAIN: '/subsidy',
        DIFA2023: '/difa2023', //시승행사 difa2023
    },
    APP_LINK: '/applink',
    MAP: {
        MAIN: '/stationMap',
        SERVICE_MAP: '/serviceMap',
    },
}

/*
 * @constant OUTER_URL 외부 PAGE URL
 */
export const OUTER_URL = {
    YOUTUBE_BATTERY_CHANGE: 'https://www.youtube.com/watch?v=DG_utQmi7rs',
    YOUTUBE_VIVA: 'https://www.youtube.com/watch?v=h8n41wUiw50',
    GOGORO_HOME: 'https://www.gogoro.com/',
    SUSIDY: 'https://ev.or.kr/nportal/buySupprt/initSubsidyPaymentCheckAction.do', //지자체별 보조금
    SNS_BLOG: 'https://blog.naver.com/dotstation_', //SNS BLOG
    SNS_POST: 'https://post.naver.com/dotstation_kr', //SNS POST
    SNS_INSTA: ' //www.instagram.com/bikebank_dotstation', //SNS INSTAGRAM
    SNS_KAKAO: 'https://pf.kakao.com/_KCBxaxj', //SNS KAKAOTALK
    GOGORO_HOMPAGE: 'https://evbikemall.co.kr/', //고고로사이트
    PERSONAL_TERMS: 'https://terms.dotstation.kr/agreement/agreement05_202510291600.html', //개인정보처리 약관
    LOCATION_TERMS: 'https://terms.dotstation.kr/agreement/agreement03_202504141430.html', //위치기반서비스 이용약관
}

/*
 * @constant COLOR 컬러색상
 */
export const COLOR = {
    BLACK: '#000000',
    WHITE: '#FFFFFF',
    BLUE_COBALT: '#0069D2',
}

/**
 * api code
 * @constant {{get, post, delete, put: string}}
 */
export const API_CODE = {
    SUCCESS: '00',
    FAIL: '99',
}

/*
 * 요금제구분
 * @constant PLAN_TYPE
 */
export const PLAN_TYPE = {
    LIMITED: '1', //정액제
    UNLIMITED: '3', //무제한
    FREEDOM: '7', //자유형
}

/*
 * 고객지원-EG CARE - 표준부품가격에서의 BIKE DATA
 * @constant PARTS_BIKE_DATA
 */
export const PARTS_BIKE_DATA = [
    {
        BIKE_MAKER: '',
        BIKE_MAKER_NM: '',
        BIKE_TYPE_NM: '전체',
        BIKE_TYPE: '',
    },
    {
        BIKE_MAKER: '00',
        BIKE_MAKER_NM: 'DOTSTATION',
        BIKE_TYPE_NM: 'GOGORO2 UTILITY',
        BIKE_TYPE: '00005',
    },
    {
        BIKE_MAKER: '00',
        BIKE_MAKER_NM: 'DOTSTATION',
        BIKE_TYPE_NM: 'GOGORO2 PLUS',
        BIKE_TYPE: '00006',
    },
    {
        BIKE_MAKER: '00',
        BIKE_MAKER_NM: 'DOTSTATION',
        BIKE_TYPE_NM: 'GOGORO S2 ABS',
        BIKE_TYPE: '00012',
    },
    {
        BIKE_MAKER: '00',
        BIKE_MAKER_NM: 'DOTSTATION',
        BIKE_TYPE_NM: 'EV-C1',
        BIKE_TYPE: '00020',
    },
]
